import React, { useState } from 'react';
import { UserService } from './../../service/user.service';
import Alert from '../common/Alert';

const ChangePassword = (params) => {
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordMessage, setPasswordMessage] = useState('');
    const [confirmPasswordMessage, setConfirmPasswordMessage] = useState('');

    const userService = new UserService();

    const changePassword = async () => {
        if (checkValidation()) {
            const vm = {
                email: params.data.email,
                password: password,
                applicationId: params.applicationId
            };

            let saveResult = await userService.changePassword(vm);
            if (saveResult.status === 200) {
                setAlertMessage(saveResult.data.isSuccess ? "Password updated successfully" : saveResult.data.message);
                alertOn(true);
            }
            else {
                setAlertMessage("Something wrong, please try again!");
                alertOn(true);
            }
        }
    };

    const setValue = async (value, tag) => {
        if (tag === "password") {
            setPassword(value);
            setPasswordMessage("");
        }
        else if (tag === "confirmPassword") {
            setConfirmPassword(value);
            if (value !== password) {
                setConfirmPasswordMessage("Password and confirm password not same!");
            }
            else {
                setConfirmPasswordMessage("");
            }
        }
    };

    const checkValidation = async () => {
        let result = true;

        if (!password || password.length === 0) {
            result = false;
            setPasswordMessage("Password is required!");
        }

        if (!confirmPassword || confirmPassword.length === 0) {
            result = false;
            setConfirmPasswordMessage("Confirm password is required!");
        }

        if (result === true && password !== confirmPassword) {
            result = false;
            setConfirmPasswordMessage("Password and confirm password not same!");
        }

        return result;
    };

    const alertOff = () => {
        setIsAlert(false);
        params.onClose();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ maxWidth: "500px", minWidth: "350px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Change Password
                </h5>
                <div className="card-body">
                    <div className="ag-theme-alpine">
                        <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                            <div>
                                <label>Password</label>
                                <input type="password" className="form-control" id="password" name="password" value={password} onChange={(e) => setValue(e.target.value, "password")} required />
                                <div>
                                    <span style={{ color: "red" }}>{passwordMessage}</span>
                                </div>
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <label>Change Password</label>
                                <input type="password" className="form-control" id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setValue(e.target.value, "confirmPassword")} required />
                                <div>
                                    <span style={{ color: "red" }}>{confirmPasswordMessage}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" onClick={changePassword}>Update</button>
                        <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;